import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useCart } from '../../context/CartContext';
import { useFavourites } from '../../context/FavouritesContext';
import { useNavigate } from 'react-router-dom';

const LINKS = [
  { name: 'HOME', url: '/' },
  { name: 'ABOUT US', url: '/about' },
  { name: 'PRODUCTS', url: '/products' },
  { name: 'BLOG', url: '/blog' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  const { itemCount, setDrawerOpen } = useCart();
  const { favourites } = useFavourites();
  const navigate = useNavigate();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <header className={`nav-header ${scrolled ? 'nav--scrolled' : ''} ${open ? 'nav--menu-open' : ''}`}>
      <div className="nav__inner">

        <a href="/" className="nav__logo">
          <div className="nav__logo-circle">
            <img src="/logo_nav.png" alt="SA" />
          </div>
          SA <span>DROPPED</span>
        </a>

        <nav className="nav__desktop-links">
          {LINKS.map(l => (
            <a key={l.name} href={l.url} className="nav__link">{l.name}</a>
          ))}
        </nav>

        <div className="nav__utils">
          
          {/* Favourites Button - Icon only, visible on mobile and desktop */}
          <button 
            className="nav__util-btn" 
            style={{ position: 'relative' }}
            aria-label="Favourites" 
            onClick={() => navigate('/favourites')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            {favourites.length > 0 && (
              <span style={{
                position: 'absolute', top: -2, right: -2,
                width: 15, height: 15, borderRadius: '50%',
                background: '#da291c', color: '#fff',
                fontSize: 8, fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>{favourites.length}</span>
            )}
          </button>

          {/* Cart Button */}
          <button 
            className="nav__util-btn" 
            style={{ position: 'relative' }} 
            aria-label="Cart" 
            onClick={() => setDrawerOpen(true)}
          >
            {itemCount > 0 && (
              <span style={{
                position: 'absolute', top: -2, right: -2,
                width: 15, height: 15, borderRadius: '50%',
                background: '#da291c', color: '#fff',
                fontSize: 8, fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: '1.5px solid #fff',
              }}>{itemCount}</span>
            )}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>
              <path d="M3 6h18"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
          </button>

          <button
            className={`nav__burger ${open ? 'active' : ''}`}
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            <div className="burger-box">
              <span className="burger-line top"></span>
              <span className="burger-line bottom"></span>
            </div>
          </button>
        </div>
      </div>

      <div className={`mobile-overlay ${open ? 'is-visible' : ''}`}>
        <div className="overlay-content">
          <nav className="mobile-nav">
            {LINKS.map((link, i) => (
              <a
                key={link.name}
                href={link.url}
                className="mobile-nav-link"
                style={{ transitionDelay: `${0.1 + i * 0.08}s` }}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => setOpen(false)}
              >
                <span className="link-index">0{i + 1}</span>
                <span className={`link-text ${hovered !== null && hovered !== i ? 'dimmed' : ''}`}>
                  {link.name}
                </span>
                <div className="link-arrow">→</div>
              </a>
            ))}
          </nav>

          <div className="overlay-footer">
            <div className="overlay-tagline">COP THE FRESH.<br/>DROP THE REST.</div>
            <div className="overlay-socials">
              <a href="https://www.instagram.com/sa_dropped" target="_blank" rel="noreferrer">INSTAGRAM</a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}